<template>
  <div>
    <section>
      <b-row class="justify-content-center align-items-stretch match-height">
        <b-col
          lg="6"
          md="6"
          sm="8"
          class="mb-2"
        >
          <b-card
            text-variant="center"
            class="card card-congratulations shadow-lg rounded-lg p-3 h-100"
          >
            <!-- Decorative images -->
            <b-img
              :src="require('@/assets/images/elements/decore-left.png')"
              class="congratulations-img-left"
              fluid
              height="40px"
            />
            <b-img
              :src="require('@/assets/images/elements/decore-right.png')"
              class="congratulations-img-right"
              fluid
              height="40px"
            />

            <!-- Title -->
            <h1 class="mb-4 mt-2 text-white font-weight-bold">
              {{ $t('indicacao.titleCardCongratulations') }}
            </h1>

            <!-- Links Container -->
            <div class="links-container">
              <!-- Registration Link -->
              <div
                v-if="indicacao && indicacao.linkRegistro"
                class="link-item mb-3"
              >
                <label class="text-white mb-1 d-block text-left">
                  <feather-icon
                    icon="LinkIcon"
                    size="16"
                    class="mr-1"
                  />
                  {{ $t('indicacao.titleLinkRegistro') }}
                </label>
                <b-button
                  v-ripple.400="'rgba(59, 130, 246, 0.15)'"
                  variant="light"
                  size="sm"
                  class="w-100 d-flex align-items-center justify-content-between text-wrap"
                  @click="copyLink(indicacao.linkRegistro)"
                >
                  <span class="text-truncate">{{ indicacao.linkRegistro }}</span>
                  <feather-icon
                    icon="CopyIcon"
                    size="16"
                    class="ml-2 flex-shrink-0"
                  />
                </b-button>
              </div>

              <!-- Landing Page Link -->
              <div
                v-if="indicacao && indicacao.linkLandpage"
                class="link-item"
              >
                <label class="text-white mb-1 d-block text-left">
                  <feather-icon
                    icon="LinkIcon"
                    size="16"
                    class="mr-1"
                  />
                  {{ $t('indicacao.titleLinkLandpage') }}
                </label>
                <b-button
                  v-ripple.400="'rgba(59, 130, 246, 0.15)'"
                  variant="light"
                  size="sm"
                  class="w-100 d-flex align-items-center justify-content-between text-wrap"
                  @click="copyLink(indicacao.linkLandpage)"
                >
                  <span class="text-truncate">{{ indicacao.linkLandpage }}</span>
                  <feather-icon
                    icon="CopyIcon"
                    size="16"
                    class="ml-2 flex-shrink-0"
                  />
                </b-button>
              </div>
            </div>
          </b-card>
        </b-col>

        <!-- Card de Estatísticas -->
        <b-col
          lg="6"
          md="6"
          sm="8"
          class="mb-2"
        >
          <b-card
            :title="$t('indicacao.titleCardStatistics')"
            class="shadow-lg rounded-lg h-100"
          >
            <b-row
              v-if="estatistica"
              class="text-center align-items-center h-100"
            >
              <b-col
                xl="4"
                sm="6"
                class="text-center"
              >
                <h4>{{ $t('indicacao.cardTextAtivos') }}</h4>
                <h1 class="font-weight-bolder my-3 text-success">
                  {{ estatistica.cadastroAtivo }}
                </h1>
              </b-col>
              <b-col
                xl="4"
                sm="6"
                class="text-center"
              >
                <h4>{{ $t('indicacao.cardTextPendentes') }}</h4>
                <h1 class="font-weight-bolder my-3 text-warning">
                  {{ estatistica.cadastroPendente }}
                </h1>
              </b-col>
              <b-col
                xl="4"
                sm="6"
                class="text-center"
              >
                <h4>{{ $t('indicacao.cardTextVencidos') }}</h4>
                <h1 class="font-weight-bolder my-3 text-danger">
                  {{ estatistica.cadastroVencido }}
                </h1>
              </b-col>
            </b-row>
          </b-card>
        </b-col>

        <b-col
          lg="12"
          md="12"
          sm="12"
          class="mb-2"
        >
          <b-card
            :title="$t('indicacao.titleBonus')"
            class="shadow-lg rounded-lg h-100"
          >

            <b-row class="d-flex flex-wrap justify-content-center">
              <b-col
                v-for="bonus in bonusRangos"
                :key="bonus.nivel"
                xl="3"
                lg="4"
                md="6"
                sm="12"
                class="mb-4 d-flex"
              >
                <b-card
                  class="w-100 d-flex flex-column align-items-center justify-content-between position-relative shadow-sm p-2"
                  body-class="d-flex flex-column w-100"
                  :border-variant="getBadgeVariantStatus(bonus.nivel)"
                >
                  <!-- Badge de status no canto superior direito -->
                  <div
                    class="position-absolute"
                    style="top: 8px; right: 8px; z-index: 10;"
                  >
                    <b-badge
                      :variant="getBadgeVariantStatus(bonus.nivel)"
                      class="px-2 py-1"
                    >
                      {{ getTextoStatus(bonus.nivel) }}
                    </b-badge>
                  </div>

                  <!-- Check de conquista no canto superior esquerdo -->
                  <div
                    v-if="bonusConquistado(bonus.nivel)"
                    class="position-absolute"
                    style="top: 8px; left: 8px; z-index: 10;"
                  >
                    <b-avatar
                      variant="light-success"
                      size="sm"
                    >
                      <feather-icon
                        icon="CheckIcon"
                        size="20"
                        class="text-success"
                      />
                    </b-avatar>
                  </div>

                  <!-- Título do bônus com avatar -->
                  <div class="d-flex align-items-center justify-content-center mb-1 mt-3 w-100">
                    <b-avatar
                      :src="require(`@/assets/images/bonus/${bonus.nivel}.png`)"
                      size="70px"
                      :variant="bonusConquistado(bonus.nivel) ? 'light-success' : 'light-primary'"
                    />
                  </div>

                  <!-- Valor - Flexbox container -->
                  <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
                    <span
                      :class="['fw-bolder', bonusConquistado(bonus.nivel) ? 'text-success' : 'text-success']"
                      style="font-size: 2rem; display: block;"
                    >
                      + ${{ bonus.valor }}
                    </span>
                  </div>

                  <!-- Status atual e requisitos faltantes -->
                  <div class="w-100 mb-2">
                    <div
                      v-if="!bonusConquistado(bonus.nivel)"
                      :class="['text-center py-2 px-3 rounded text-muted']"
                      style="background-color: rgba(0,0,0,0.03); min-height: 50px; display: flex; align-items: center; justify-content: center;"
                    >
                      <span style="font-size: 0.9rem; line-height: 1.4;">
                        {{ interpretarRequisitos(bonus.nivel) }}
                      </span>
                    </div>
                    <div
                      v-else
                      :class="['text-center py-2 px-3 rounded text-success']"
                      style="background-color: rgba(40, 199, 111, 0.1); min-height: 50px; display: flex; align-items: center; justify-content: center;"
                    >
                      <div style="font-size: 0.9rem; line-height: 1.4;">
                        <div>{{ $t('indicacao.bonus.cards.conquistadoMensagem') }}</div>
                        <div
                          v-if="getDataConquista(bonus.nivel)"
                          class="text-muted mt-1"
                          style="font-size: 0.8rem;"
                        >
                          {{ $t('indicacao.bonus.cards.conquistadoEm') }} {{ formatarData(getDataConquista(bonus.nivel)) }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Requisitos gerais (apenas para bônus inativos) -->
                  <div
                    v-if="bonus.requisitos && bonus.requisitos.length > 0"
                    class="w-100"
                  >
                    <b-list-group
                      flush
                      class="mb-2 w-100"
                    >
                      <b-list-group-item class="py-1 px-2 border-0 bg-transparent">
                        <div class="fw-bold text-primary d-flex align-items-center mb-1">
                          <b-badge
                            variant="light-primary"
                            class="ms-0"
                          >
                            <feather-icon
                              icon="TargetIcon"
                              size="15"
                              class="me-1"
                            />
                            {{ $t('indicacao.bonus.cards.requisitosGerais') }}
                          </b-badge>
                        </div>
                        <ul class="list-unstyled mb-0 mt-1">
                          <li
                            v-for="(req, idx) in bonus.requisitos"
                            :key="idx"
                            class="d-flex align-items-start mb-2"
                            style="font-size: 0.85rem; line-height: 1.4;"
                          >
                            <feather-icon
                              icon="ArrowRightIcon"
                              size="12"
                              class="me-3 text-muted flex-shrink-0"
                              style="margin-top: 2px;"
                            />
                            <span>{{ req }}</span>
                          </li>
                        </ul>
                      </b-list-group-item>
                    </b-list-group>
                  </div>

                  <!-- Benefícios do bônus (sempre mostrar quando disponível) -->
                  <div
                    v-if="bonus.bonusReceber && bonus.bonusReceber.length > 0"
                    class="w-100"
                  >
                    <b-list-group
                      flush
                      class="mb-2 w-100"
                    >
                      <b-list-group-item class="py-1 px-2 border-0 bg-transparent">
                        <div class="fw-bold text-success d-flex align-items-center mb-1">
                          <b-badge
                            variant="light-success"
                            class="ms-0"
                          >
                            <feather-icon
                              icon="GiftIcon"
                              size="15"
                              class="me-1"
                            />
                            {{ $t('indicacao.bonus.cards.beneficios') }}
                          </b-badge>
                        </div>
                        <ul class="list-unstyled mb-0 mt-1">
                          <li
                            v-for="(beneficio, idx) in bonus.bonusReceber"
                            :key="idx"
                            class="d-flex align-items-start mb-2"
                            style="font-size: 0.85rem; line-height: 1.4;"
                          >
                            <feather-icon
                              icon="CheckCircleIcon"
                              size="12"
                              class="me-3 text-success flex-shrink-0"
                              style="margin-top: 2px;"
                            />
                            <span>{{ beneficio }}</span>
                          </li>
                        </ul>
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </b-card>
              </b-col>
            </b-row>
          </b-card>
        </b-col>

      </b-row>
    </section>
  </div>
</template>

<script>
import {
  BCard,
  BImg,
  BRow,
  BCol,
  BButton,
  BBadge,
  BAvatar,
  BListGroup,
  BListGroupItem,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import utilsMixin from '@/mixins/utilsMixin'
import Ripple from 'vue-ripple-directive'
import indicacaoStoreModule from './indicacaoStoreModule'

const INDICACAO_STORE_MODULE_NAME = 'indicacao'

export default {

  components: {
    BCard,
    BImg,
    BRow,
    BCol,
    BButton,
    BBadge,
    BAvatar,
    BListGroup,
    BListGroupItem,
  },

  directives: {
    Ripple,
  },

  mixins: [utilsMixin],

  data() {
    return {
      indicacao: null,
      estatistica: null,
      bonusRangos: [],
      bonusEmpresa: [], // Dados dos bônus da empresa
      usuarioBonus: [], // Status dos bônus do usuário
      loading: true,
    }
  },

  created() {
    if (!store.hasModule(INDICACAO_STORE_MODULE_NAME)) store.registerModule(INDICACAO_STORE_MODULE_NAME, indicacaoStoreModule)
    this.getIndicacao()
    this.getEstatistica()
    this.carregarBonus() // Carregar dados dos bônus
  },

  beforeDestroy() {
    if (store.hasModule(INDICACAO_STORE_MODULE_NAME)) store.unregisterModule(INDICACAO_STORE_MODULE_NAME)
  },

  methods: {

    getEstatistica() {
      this.loading = true
      store
        .dispatch('indicacao/getEstatistica')
        .then(response => {
          this.estatistica = response.data.estatistica
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao carregar estatísticas',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    getIndicacao() {
      store
        .dispatch('indicacao/getIndicacao')
        .then(response => {
          this.indicacao = response.data
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao carregar indicação',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },

    copyLink(linkText) {
      // Cria um elemento de input temporário
      const input = document.createElement('input')
      input.style.opacity = 0
      input.value = linkText
      document.body.appendChild(input)

      // Seleciona o texto no input
      input.select()
      input.setSelectionRange(0, linkText.length)

      // Executa o comando de cópia
      document.execCommand('copy')

      // Remove o input temporário
      document.body.removeChild(input)

      // Exibe uma mensagem ou feedback de sucesso
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Link copiado!',
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
    },

    // Método principal para carregar todos os dados de bônus
    carregarBonus() {
      this.loading = true

      // Buscar dados dos bônus da empresa e status do usuário em paralelo
      Promise.all([
        store.dispatch('indicacao/getBonusEmpresa'),
        store.dispatch('indicacao/getBonus'),
      ])
        .then(([bonusEmpresaResponse, usuarioBonusResponse]) => {
          this.bonusEmpresa = bonusEmpresaResponse.data || []
          this.usuarioBonus = usuarioBonusResponse.data || []
          this.processarBonusRangos()
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao carregar bônus',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          this.bonusEmpresa = []
          this.usuarioBonus = []
          this.bonusRangos = []
        })
        .finally(() => {
          this.loading = false
        })
    },

    // Método atualizado para buscar apenas status do usuário (para reclassificação)
    getUsuarioBonus() {
      this.loading = true
      store
        .dispatch('indicacao/getBonus')
        .then(response => {
          this.usuarioBonus = response.data || []
          this.processarBonusRangos()
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao carregar seus bônus',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          this.usuarioBonus = []
          this.bonusRangos = []
        })
        .finally(() => {
          this.loading = false
        })
    },

    // Método atualizado para processar os bônus combinando dados da empresa e do usuário
    processarBonusRangos() {
      if (!this.bonusEmpresa || this.bonusEmpresa.length === 0) {
        this.bonusRangos = []
        return
      }

      // Usar os níveis que vêm do backend, ordenados por ID ou ordem específica
      this.bonusRangos = this.bonusEmpresa
        .sort((a, b) => {
          // Ordenar por ID ou por uma propriedade de ordem se existir
          if (a.ordem && b.ordem) return a.ordem - b.ordem
          if (a.id && b.id) return a.id - b.id
          return a.nivel.localeCompare(b.nivel) // Fallback para ordem alfabética
        })
        .map(bonusEmpresa => {
          // Buscar status do usuário para este nível
          const bonusUsuario = this.usuarioBonus.find(b => b.bonusNivel === bonusEmpresa.nivel)

          return {
            nivel: bonusEmpresa.nivel,
            valor: bonusEmpresa.valor,
            id: bonusEmpresa.id,
            ordem: bonusEmpresa.ordem,
            requisitos: bonusEmpresa.descricoes
              ? bonusEmpresa.descricoes
                .filter(desc => desc && desc.tipo === 'R' && desc.descricao)
                .map(desc => desc.descricao)
              : [],
            bonusReceber: bonusEmpresa.descricoes
              ? bonusEmpresa.descricoes
                .filter(desc => desc && desc.tipo === 'B' && desc.descricao)
                .map(desc => desc.descricao)
              : [],
            bonusUsuario, // Status do usuário para este bônus
            bonusEmpresa, // Dados completos da empresa
          }
        })
    },

    // Retorna true se o bônus já foi conquistado
    bonusConquistado(nivel) {
      const bonus = this.usuarioBonus.find(b => b.bonusNivel === nivel)
      return bonus && (bonus.statusCodigo === 1 || bonus.statusCodigo === 2) // CONQUISTADO ou ATIVO
    },

    // Retorna true se o bônus está ativo (para comissões)
    bonusAtivo(nivel) {
      const bonus = this.usuarioBonus.find(b => b.bonusNivel === nivel)
      return bonus && bonus.statusCodigo === 2 // ATIVO
    },

    // Interpreta requisitos do JSON para texto formatado
    interpretarRequisitos(nivel) {
      const bonus = this.usuarioBonus.find(b => b.bonusNivel === nivel)

      if (!bonus) {
        // Bônus ainda não desbloqueado - encontrar qual nível anterior precisa ser alcançado
        const nivelAnterior = this.encontrarNivelAnteriorNecessario(nivel)
        if (nivelAnterior) {
          return this.$t('indicacao.bonus.cards.proximoBonusMensagem', { nivel: nivelAnterior })
        }
        return this.$t('indicacao.bonus.cards.bonusIndisponivel')
      }

      // Verificar status do bônus para mostrar mensagem apropriada
      switch (bonus.statusCodigo) {
        case 2: // ATIVO
          return this.$t('indicacao.bonus.cards.ativoMensagem')
        case 3: // SUSPENSO
          return this.$t('indicacao.bonus.cards.suspensoMensagem')
        case 0: // INATIVO - mostrar requisitos faltantes
        default:
          break
      }

      // Para status INATIVO, processar requisitos faltantes
      if (!bonus.requisitosFaltantes) {
        return this.$t('indicacao.bonus.cards.semRequisitos')
      }

      const { mensagem } = bonus.requisitosFaltantes

      if (!mensagem || !mensagem.tipo) {
        return this.$t('indicacao.bonus.cards.erroCarregar')
      }

      try {
        // Buscar tradução
        const template = this.$t(`indicacao.bonus.requisitos.${mensagem.tipo}`)
        let textoFinal = template

        // Interpolar parâmetros
        if (mensagem.parametros) {
          Object.keys(mensagem.parametros).forEach(key => {
            const valor = mensagem.parametros[key]

            // Tratar pluralização
            if (key === 'plural' && valor) {
              textoFinal = textoFinal.replace(/{plural:([^:}]+):([^}]*)}/g, '$1$2')
            } else if (key !== 'plural') {
              textoFinal = textoFinal.replace(new RegExp(`{${key}}`, 'g'), valor)
            }
          })
        }

        // Limpar marcadores de plural não utilizados
        textoFinal = textoFinal.replace(/{plural:[^}]*}/g, '')

        return textoFinal
      } catch (error) {
        return this.$t('indicacao.bonus.cards.erroCarregar')
      }
    },

    // Encontra qual nível anterior precisa ser alcançado para desbloquear este bônus
    encontrarNivelAnteriorNecessario(nivelAtual) {
      if (!this.bonusRangos || this.bonusRangos.length === 0) return null

      // Encontrar posição do nível atual
      const indiceAtual = this.bonusRangos.findIndex(b => b.nivel === nivelAtual)
      if (indiceAtual <= 0) return null

      // Verificar níveis anteriores para encontrar o primeiro não conquistado
      for (let i = indiceAtual - 1; i >= 0; i -= 1) {
        const nivelAnterior = this.bonusRangos[i].nivel
        const bonusAnterior = this.usuarioBonus.find(b => b.bonusNivel === nivelAnterior)

        // Se não tem registro ou não está conquistado/ativo, é este que precisa ser alcançado
        if (!bonusAnterior || (bonusAnterior.statusCodigo !== 1 && bonusAnterior.statusCodigo !== 2)) {
          return nivelAnterior
        }
      }

      return null
    },

    // Obtém badge variant baseado no status
    getBadgeVariantStatus(nivel) {
      const bonus = this.usuarioBonus.find(b => b.bonusNivel === nivel)

      if (!bonus) {
        return 'secondary'
      }

      switch (bonus.statusCodigo) {
        case 0: // INATIVO
          return 'secondary'
        case 1: // CONQUISTADO
          return 'success'
        case 2: // ATIVO
          return 'success'
        case 3: // SUSPENSO
          return 'warning'
        default:
          return 'secondary'
      }
    },

    // Obtém texto do status
    getTextoStatus(nivel) {
      const bonus = this.usuarioBonus.find(b => b.bonusNivel === nivel)

      if (!bonus) {
        return this.$t('indicacao.bonus.status.INATIVO')
      }

      return this.$t(`indicacao.bonus.status.${bonus.statusDescricao.toUpperCase()}`)
    },

    // Método dinâmico para obter variant baseado na posição do bônus
    getBadgeVariant(nivel) {
      // Buscar o bônus nos dados da empresa para obter sua posição/ordem
      const bonus = this.bonusEmpresa.find(b => b.nivel === nivel)
      if (!bonus) return 'primary'

      // Se o backend fornecer uma propriedade 'cor' ou 'variant', usar ela
      if (bonus.cor) return bonus.cor
      if (bonus.variant) return bonus.variant

      // Caso contrário, usar um sistema baseado na ordem/posição
      const variants = ['secondary', 'primary', 'info', 'success', 'warning', 'danger', 'dark']
      const index = this.bonusEmpresa.findIndex(b => b.nivel === nivel)
      return variants[index % variants.length] || 'primary'
    },

    // Obtém a data da conquista do bônus
    getDataConquista(nivel) {
      const bonus = this.usuarioBonus.find(b => b.bonusNivel === nivel)
      return bonus && bonus.dataConquista ? bonus.dataConquista : null
    },

    // Formata a data para exibição
    formatarData(dataString) {
      if (!dataString) return ''

      try {
        const data = new Date(dataString)
        return data.toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })
      } catch (error) {
        return dataString
      }
    },
  },

}
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

.dark-layout {
  div ::v-deep {
      .b-overlay {
        .bg-light {
          background-color: $theme-dark-body-bg !important;
        }
      }
  }
}

.card-congratulations {
  position: relative;
  overflow: hidden;
  .congratulations-img-left {
    position: absolute;
    left: 0;
    top: 0;
  }
  .congratulations-img-right {
    position: absolute;
    right: 0;
    top: 0;
  }
  .links-container {
    max-width: 100%;
    margin: 0 auto;
  }
  .link-item {
    background: #151517;
    border: 1px solid rgba(255, 255, 255, 0.10);
    border-radius: 0.5rem;
    padding: 0.75rem;
    label {
      font-size: 0.875rem;
      font-weight: 500;
    }
    .btn {
      background: rgba(255, 255, 255, 0.06);
      border: none;
      padding: 0.5rem 1rem;
      &:hover {
        background: rgba(255, 255, 255, 0.12);
      }
    }
  }
}

.bonus-card-custom {
  min-height: 370px;
  max-width: 340px;
  margin: 0 auto;
  border-radius: 1rem;
  box-shadow: none;
  transition: box-shadow 0.2s;
  &:hover {
    box-shadow: 0 4px 24px 0 rgba(0,0,0,.4);
  }
}
</style>
